const textFieldModelDocCompany = {
  company: 'Empresa'
};

export default textFieldModelDocCompany;
